export default function Playlist(props) {
    return (
        <div className="Playlist">
            <h3>Playlista</h3>
            <table>
                <tr>
                    <th>Vrijeme</th>
                    <th>Izvođač</th>
                    <th>Pjesma</th>
                </tr>
                {props.playlist.map((item, i) => {
                    return (<tr key={i}>
                        <td>{item.time}</td>
                        <td>{item.artist}</td>
                        <td>{item.song}</td>
                    </tr>)

                })}
            </table>
        </div>
    );
}